var _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.677083,
    y: 0.677083,
    width: 4.27917,
    height: 1.67917,
    stroke: "#DDDDDD",
    strokeWidth: 1.35417
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.04427,
    y: 0.677083,
    width: 4.27917,
    height: 5.14583,
    stroke: "#DDDDDD",
    strokeWidth: 1.35417
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.04427,
    y: 8.91048,
    width: 4.27917,
    height: 3.4125,
    stroke: "#DDDDDD",
    strokeWidth: 1.35417
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.677083,
    y: 5.44368,
    width: 4.27917,
    height: 6.87917,
    stroke: "#DDDDDD",
    strokeWidth: 1.35417
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgDashboard);
export default __webpack_public_path__ + "static/media/org-dashboard.333bbe943f53c55a3acaafc321ec781f.svg";
export { ForwardRef as ReactComponent };